import { IDataProvider } from "../../Data/IDataProvider";
import { resourceNameGoal } from "../../Entity/IGoal";
import { IGoalWithDatapoints } from "../DatapointRepository";
import { goalsRepository } from "./GoalsRepository_Main";

const UpdateGoalsRepository = () => {
    async function UpdateGoalAsync(
        dataProvider: IDataProvider,
        goal: Partial<IGoalWithDatapoints>,
        shouldAddWeeklyRateChangeDataPoint: boolean
    ) {
        await dataProvider.UpdateRecordAsync(
            `${resourceNameGoal}?id=eq.${goal.id}`,
            goal
        );

        await goalsRepository.AddWeeklyRateChangeDataPointAsync(
            shouldAddWeeklyRateChangeDataPoint,
            goal,
            dataProvider
        );
    }

    return {
        UpdateGoalAsync,
    };
};

export const updateGoalsRepository = UpdateGoalsRepository();
